/* eslint-disable object-shorthand */
/* eslint-disable react/style-prop-object */
import anime from 'animejs/lib/anime.es';
import Box from '@ui-kit/box';
import { useEffect } from 'preact/hooks';

function AiLoadingAnimation() {
  const timeline = anime.timeline({
    autoplay: true,
    loop: true,
  });

  useEffect(() => {
    timeline
      .add(
        {
          targets: '#circle-ball',
          rotate: 360,
          duration: 3000,
          easing: 'easeInOutSine',
        },
        100,
      )
      .add(
        {
          targets: '#artifact',
          scale: [1, 1.2],
          opacity: [0.8, 1, 0],
          translateY: [0, anime.random(-10, 10)],
          duration: 3000,
          delay: anime.stagger(50),
          easing: 'easeInOutSine',
        },
        100,
      )
      .add(
        {
          targets: '#ripple-inside',
          opacity: [1, 1, 1, 1, 0],
          scale: [0.2, 1.6],
          duration: 2400,
          easing: 'easeInOutSine',
        },
        100,
      )
      .add(
        {
          targets: '#ripple-outside',
          opacity: [0.25, 1, 1, 0],
          scale: [0.5, 1.2, 1.6],
          duration: 2400,
          easing: 'easeInOutSine',
        },
        100,
      )
      .add(
        {
          targets: '#logo-parts',
          opacity: [0.6, 1, 1, 0.25],
          duration: 2400,
          easing: 'easeInOutSine',
        },
        50,
      );
    timeline.play();
  }, []);

  return (
    <Box position="relative" style={{ overflow: 'visible' }}>
      <svg width="231px" height="231px" viewBox="0 0 231 231" version="1.1" style="overflow: visible">
        <g
          id="Page-1"
          stroke="none"
          strokeWidth="1"
          fill="none"
          fillRule="evenodd"
        >
          <g
            id="iPhone-13-Pro-Copy-24"
            transform="translate(-81.000000, -164.000000)"
          >
            <g
              id="Group-4"
              transform="translate(81.000000, 164.000000)"
              style="transform-origin: center;"
            >
              <path
                style="transform-origin: center;"
                id="artifact"
                d="M111.000025,23.99998 L113.431261,30.5687581 L120.00005,32.99998 L113.431261,35.4312219 L111.000025,42 L108.568789,35.4312219 L102,32.99998 L108.568789,30.5687581 L111.000025,23.99998 Z M123.600007,38.99993 C123.600007,40.3327256 121.600007,40.3327256 121.600007,38.99993 C121.600007,37.6671344 123.600007,37.6671344 123.600007,38.99993 Z M121.600007,18 L122.787525,21.2124693 L126,22.3999853 L122.787525,23.5875014 L121.600007,26.7999707 L120.412489,23.5875014 L117.200015,22.3999853 L120.412489,21.2124693 L121.600007,18 Z M106.000037,21.7999873 C106.000037,23.1327829 104.000037,23.1327829 104.000037,21.7999873 C104.000037,20.4671918 106.000037,20.4671918 106.000037,21.7999873 Z"
                fill="var(--inactive)"
                fillRule="nonzero"
              />
              <path
                style="transform-origin: center;"
                id="artifact"
                d="M78.6000073,185 L79.7875254,188.212469 L83,189.399985 L79.7875254,190.587501 L78.6000073,193.799971 L77.4124893,190.587501 L74.2000147,189.399985 L77.4124893,188.212469 L78.6000073,185 Z M80.6000073,205.99993 C80.6000073,207.332726 78.6000073,207.332726 78.6000073,205.99993 C78.6000073,204.667134 80.6000073,204.667134 80.6000073,205.99993 M63.0000367,188.799987 C63.0000367,190.132783 61.0000367,190.132783 61.0000367,188.799987 C61.0000367,187.467192 63.0000367,187.467192 63.0000367,188.799987"
                fill="var(--inactive)"
                fillRule="nonzero"
              />
              <circle
                style="transform-origin: center;"
                id="artifact"
                fill="var(--inactive)"
                cx="182.5"
                cy="57.5"
                r="3.5"
              />
              <circle
                style="transform-origin: center;"
                id="artifact"
                fill="var(--inactive)"
                cx="45.5"
                cy="172.5"
                r="3.5"
              />
              <circle
                style="transform-origin: center;"
                id="artifact"
                fill="var(--inactive)"
                cx="33.5"
                cy="115.5"
                r="3.5"
              />
              <circle
                style="transform-origin: center;"
                id="artifact"
                fill="var(--inactive)"
                cx="49.5"
                cy="57.5"
                r="6.5"
              />
              <circle
                style="transform-origin: center;"
                id="artifact"
                fill="var(--inactive)"
                cx="115.5"
                cy="195.5"
                r="5.5"
              />
              <circle
                style="transform-origin: center;"
                id="artifact"
                fill="var(--inactive)"
                cx="196.5"
                cy="154.5"
                r="5.5"
              />
              <path
                id="artifact"
                d="M192.466822,104 C192.466822,104 192.468263,104.013488 192.471329,104.038991 L192.485595,104.150071 C192.566917,104.750808 192.93142,106.998617 193.942268,108.0156 C195.120616,109.19531 197.933644,109.5 197.933644,109.5 C197.933644,109.5 195.114851,109.8047 193.942268,110.9844 C192.769674,112.1699 192.466822,115 192.466822,115 C192.466822,115 192.465409,114.986512 192.462391,114.961009 L192.448332,114.84993 C192.368098,114.249194 192.007194,112.001391 190.991376,110.9844 C189.813028,109.80469 187,109.5 187,109.5 C187,109.5 189.818793,109.1953 190.991376,108.0156 C192.16397,106.8301 192.466822,104 192.466822,104 Z M204.817814,87 L204.821401,87.0320887 C204.874712,87.4972011 205.537808,92.896313 207.838532,95.211 C210.239957,97.6309 216,98.25005 216,98.25005 C216,98.25005 210.243834,98.8692 207.838532,101.2891 C205.433229,103.7051 204.817814,109.5001 204.817814,109.5001 C204.817814,109.5001 204.196585,103.709 201.797097,101.2891 C199.395671,98.8692 193.635629,98.25005 193.635629,98.25005 L193.635629,98.25005 L193.667524,98.2464416 C194.12983,98.1928068 199.496373,97.525687 201.797097,95.211 C204.202399,92.795 204.817814,87 204.817814,87 L204.817814,87 Z"
                fill="var(--inactive)"
                fillRule="nonzero"
              />
              <path
                id="artifact"
                d="M160.770222,189.142857 C160.770222,189.142857 160.979092,191.1685 161.787771,192.011143 C162.600425,192.853793 164.540444,193.071429 164.540444,193.071429 C164.540444,193.071429 162.596449,193.289071 161.787771,194.131714 C160.979086,194.9785 160.770222,197 160.770222,197 C160.770222,197 160.565328,194.974364 159.752673,194.131714 C158.940019,193.289064 157,193.071429 157,193.071429 C157,193.071429 158.943995,192.853786 159.752673,192.011143 C160.561359,191.164357 160.770222,189.142857 160.770222,189.142857 Z M169.288148,177 C169.288148,177 169.712572,181.1365 171.371401,182.865 C173.027557,184.5935 177,185.03575 177,185.03575 C177,185.03575 173.03023,185.478 171.371401,187.2065 C169.758651,188.884278 169.312679,192.843402 169.289148,193.062059 L169.288,193.07 C169.2634,192.843552 168.813746,188.886986 167.204894,187.2065 C165.548739,185.478 161.576296,185.03575 161.576296,185.03575 C161.576296,185.03575 165.546065,184.5935 167.204894,182.865 C168.863724,181.139286 169.288148,177 169.288148,177 Z M161.455717,180.035714 C161.455717,181.225714 159.74198,181.225714 159.74198,180.035714 C159.74198,178.845714 161.455717,178.845714 161.455717,180.035714 Z"
                fill="var(--inactive)"
                fillRule="nonzero"
              />
              <path
                id="artifact"
                d="M32.3714012,81.865 C30.712572,80.1365 30.2881478,76 30.2881478,76 C30.2881478,76 29.8637236,80.1392857 28.2048944,81.865 C26.5460653,83.5935 22.5762956,84.03575 22.5762956,84.03575 C22.5762956,84.03575 26.5487387,84.478 28.2048944,86.2065 C29.8597135,87.935 30.2881478,92.0715 30.2881478,92.0715 C30.2881478,92.0715 30.712572,87.9322143 32.3714012,86.2065 C34.0302303,84.478 38,84.03575 38,84.03575 C38,84.03575 34.0275569,83.5935 32.3714012,81.865 Z"
                fill="var(--inactive)"
                fillRule="nonzero"
              />
              <circle
                id="ripple-outside"
                style="transform-origin: center;"
                stroke="var(--inactive)"
                cx="115.5"
                cy="115.5"
                r="111"
              />
              <circle
                id="ripple-inside"
                style="transform-origin: center;"
                stroke="var(--inactive)"
                cx="115.5"
                cy="115.5"
                r="86"
              />
              <g id="Group-3" transform="translate(0.000000, 61.000000)">
                <rect id="Rectangle" x="0" y="0" width="231" height="111" />
                <path
                  d="M120.871314,42.9243853 C122.151373,44.0036795 123.404795,45.1555792 124.624394,46.3727743 C135.242613,56.9941149 140.130178,69.5606878 134.845537,74.8481268 C131.743389,77.9480466 126.151371,77.5971614 119.707095,74.4488399 C118.940013,74.0737508 118.620618,73.1444811 118.995703,72.3773533 C119.370769,71.6078095 120.299983,71.2908109 121.067064,71.6659186 C126.455899,74.2987969 130.7437,74.5674124 132.655363,72.658111 C136.239082,69.0717592 131.975378,58.1047992 122.43422,48.565107 C121.277558,47.4083752 120.087011,46.3145846 118.874722,45.2933996 C118.221374,44.7440759 118.139109,43.7664541 118.6884,43.1130667 C119.240106,42.4572631 120.217731,42.3749934 120.871016,42.924311 L120.871314,42.9243853 Z M127.886116,58.7191767 C128.539463,59.2733387 128.619312,60.2510162 128.065178,60.9019257 C127.012586,62.1433432 125.863172,63.3871769 124.624245,64.6261784 C114.003548,75.2450409 101.437736,80.1329019 96.1530949,74.8479409 C93.0533628,71.7480211 93.4018108,66.1606818 96.5475195,59.7184934 C96.9225859,58.9513656 97.8493835,58.631951 98.6164029,59.0070587 C99.3859001,59.3821478 99.7052954,60.3090015 99.3302104,61.0785453 C96.6999075,66.4628742 96.4337241,70.7483327 98.3429099,72.657634 C101.926629,76.2415698 112.892863,71.977608 122.434455,62.4358715 C123.615276,61.2549791 124.706646,60.0740248 125.703548,58.8979646 C126.257677,58.2469932 127.232879,58.1671396 127.886165,58.7188917 L127.886116,58.7191767 Z M111.278925,36.545386 C112.046007,36.9204751 112.365402,37.8497448 111.990317,38.6168726 C111.615251,39.3864165 110.688453,39.7058311 109.918956,39.3307233 C104.534953,36.7002612 100.252232,36.4340617 98.3424267,38.343363 C94.756292,41.9272988 99.0224115,52.8941969 108.56357,62.4363671 C109.7154,63.5906829 110.903469,64.6796413 112.113404,65.6984103 C112.766752,66.2501501 112.849017,67.2278338 112.299727,67.8811593 C111.74802,68.5345467 110.770396,68.6192325 110.11711,68.0674927 C108.839467,66.9930306 107.588461,65.8411309 106.371277,64.6263518 C95.7530579,54.0050113 90.8654929,41.4384384 96.1526117,36.1534774 C99.2499279,33.0535576 104.837486,33.4020267 111.278665,36.5455037 L111.278925,36.545386 Z M115.581284,50.1236036 C115.898275,50.2058795 116.14025,50.4527134 116.217658,50.7697429 L116.858926,53.4461721 C116.970238,53.9083754 117.323524,54.2761792 117.78329,54.4044778 L120.144993,55.0675295 C120.578134,55.1885241 120.82981,55.6362126 120.708804,56.0693861 C120.628949,56.3525165 120.401494,56.5727304 120.115959,56.6404852 L117.877652,57.1777101 C117.386437,57.2962887 117.008979,57.6834767 116.900077,58.1771507 L116.23465,61.2286875 C116.135437,61.6933131 115.675684,61.9885672 115.211111,61.8869071 C114.882021,61.8143078 114.625526,61.5577973 114.555347,61.2286875 L113.88992,58.1819828 C113.783453,57.685899 113.398704,57.2986986 112.907513,57.1825422 L110.589358,56.6356407 C110.148956,56.5340055 109.877966,56.0935776 109.981992,55.6531745 C110.049749,55.3627835 110.269944,55.132893 110.555479,55.0530331 L112.885714,54.3996457 C113.335791,54.2738127 113.68668,53.918083 113.802829,53.4655624 L114.509389,50.7528306 C114.630376,50.2833667 115.111916,50.000261 115.58137,50.1236656 L115.581284,50.1236036 Z M134.845352,36.153242 C137.9475,39.2555779 137.599052,44.8628032 134.448505,51.3142841 C134.073438,52.0838279 133.144225,52.4008265 132.377144,52.0257188 C131.607646,51.6506296 131.288251,50.723776 131.665752,49.9542321 C134.300887,44.557823 134.569486,40.2578062 132.655468,38.3435489 C129.069334,34.757197 118.103038,39.0235749 108.563923,48.5653114 C107.40243,49.7244593 106.303874,50.9199099 105.280273,52.137105 C104.728566,52.7929085 103.75342,52.8751782 103.097656,52.3258607 C102.444308,51.7741209 102.359627,50.7989152 102.911334,50.1431117 C103.990562,48.8581432 105.14964,47.5973353 106.371593,46.372892 C116.992291,35.7540295 129.558103,30.8661685 134.845221,36.1536075 L134.845352,36.153242 Z"
                  id="Shape"
                  fill="var(--brand-primary)"
                  fillRule="nonzero"
                />
              </g>
              <g id="circle-ball" style="transform-origin: center;">
                <circle
                  id="Oval"
                  stroke="var(--active-nav)"
                  cx="115.5"
                  cy="116.5"
                  r="55"
                />
                <circle
                  id="Oval-Copy"
                  fill="var(--brand-primary)"
                  cx="61.5"
                  cy="104.5"
                  r="3.5"
                />
              </g>
            </g>
          </g>
        </g>
      </svg>
    </Box>
  );
}

export default AiLoadingAnimation;
